<!-- <i class="fas fa-exclamation-triangle"></i> -->
<template>
  <div class="quiz-timer-wrapper">
    <div class="quiz-timer">
      <span class="time">{{ timer }}</span>
      <span class="icon">
        <i class="fas fa-hourglass-half"></i>
      </span>
    </div>

    <!-- <div class="btn-container">
      <a @click="toggleTimer">
        {{ running ? 'Pause' : 'Resume' }}
      </a>
      <a @click="restartTimer">Reset</a>
    </div> -->
  </div>
</template>

<script>
import { getTimerStorageKey } from './helpers';
export default {
  props: ['storage_key', 'isFinished'],
  data() {
    return {
      timer: '00:00',
      timeBegan: null,
      timeStopped: null,
      stoppedDuration: 0,
      started: null,
      running: false,
    };
  },
  methods: {
    toggleTimer() {
      this.running ? this.stop() : this.start();
    },

    restartTimer() {
      this.reset();
      this.start();
    },
    getStartTimeFromStorage() {
      return parseInt(window.localStorage.getItem(getTimerStorageKey(this.storage_key))) || 0;
    },

    start() {
      if (this.running) return;
      if (this.timeBegan === null) {
        this.reset();
        this.timeBegan = new Date(Date.now() - this.getStartTimeFromStorage());
      }
      if (this.timeStopped !== null) {
        this.stoppedDuration += new Date() - this.timeStopped;
      }
      console.log('start')
      clearInterval(this.started);
      this.started = setInterval(() => {
        var timeElapsed = new Date(new Date() - this.timeBegan - this.stoppedDuration),
          hour = timeElapsed.getUTCHours(),
          min = timeElapsed.getUTCMinutes(),
          sec = timeElapsed.getUTCSeconds();
          this.timer = this.zeroPrefix(min, 2) + ':' + this.zeroPrefix(sec, 2);

        if (hour > 0) {
          this.timer = this.zeroPrefix(hour, 2) + ':' + this.timer;
        }
        if (this.storage_key) {
          let miliscends = hour * 3600000 + min * 60000 + sec * 1000;
          window.localStorage.setItem(getTimerStorageKey(this.storage_key), miliscends);
        }
      }, 1000);
      this.running = true;
    },

    stop() {
      console.log('stop')
      this.running = false;
      this.timeStopped = new Date();
      clearInterval(this.started);
    },

    reset() {
      this.running = false;
      clearInterval(this.started);
      this.stoppedDuration = 0;
      this.timeBegan = null;
      this.timeStopped = null;
      this.timer = '00:00';
    },

    zeroPrefix(num, digit) {
      var zero = '';
      for (var i = 0; i < digit; i++) {
        zero += '0';
      }
      return (zero + num).slice(-digit);
    },
  },
  watch: {
    isFinished: function (newVal, oldVal) {
      if (newVal) {
        console.log('finished')
        this.stop();
      }
    },
  },
  mounted() {
    this.start();
    window.bus.$on('resetQuizTimer', () => {
      this.reset();
      window.localStorage.removeItem(getTimerStorageKey(this.storage_key));
      this.start();
    });
  },
   destroyed () {
      clearInterval(this.started);
  },
};
</script>
<style lang="scss" scoped>
.quiz-timer-wrapper {
  .quiz-timer {
    display: flex;
    .time {
      font-weight: bold;
      color: #f35f5d;
      padding-right: 10px;
      display: flex;
      align-items: center;
    }
    .icon {
      i {
        font-size: 28px;
      }
    }
    @media only screen and (max-width: 768px) {
      .time {
        order: 2;
      }
      .icon {
        order: 1;
        margin-right: 5px;
      }
    }
  }
}
</style>
